export class AlreadyExistsError extends Error {
  readonly name: string

  readonly __proto__: AlreadyExistsError

  constructor(message = "Already exists") {
    const prototype = new.target.prototype
    super(message)
    this.__proto__ = prototype
    this.name = "ALREADY_EXISTS_ERROR"
  }
}
